import MuiTextField from "@mui/material/TextField";

import { useFieldContext } from "./useAppForm";

export function NumberField({ description, ...props }) {
  const field = useFieldContext();

  return (
    <MuiTextField
      fullWidth
      onChange={(e) => field.handleChange(Number(e.target.value))}
      type="number"
      value={field.state.value ?? ""}
      error={field.state.meta.errors.length >= 1}
      helperText={field.state.meta.errors?.map((error) => error?.message).join(" ") || description}
      {...props}
    />
  );
}
